import { ThemeUIStyleObject } from "theme-ui";

export const containerStyles: ThemeUIStyleObject = {
  position: "relative",
  display: "flex",
  justifyContent: "center",
  paddingTop: 14,
  paddingBottom: 12,
  paddingLeft: 4,
  paddingRight: 4,
  flexDirection: "column",
  bg: "darkGray",
};

export const logoStyles: ThemeUIStyleObject = {
  display: "inline-block",
  marginLeft: "auto",
  marginRight: "auto",
  marginBottom: [4, 6],
  width: [137, 168],
  height: [129, 157],
  textAlign: "center",
};

export const soMeWrapStyles: ThemeUIStyleObject = {
  display: "flex",
  justifyContent: "center",
  marginBottom: [12, 16],
};

export const soMeLinkStyles: ThemeUIStyleObject = {
  mx: 2,
  opacity: 0.7,
  borderColor: "white",
  transition: "opacity .2s ease-in",
  width: "43px",
  height: "43px",
  ":hover, :focus": {
    opacity: 1,
  },
};

export const centerContainerWrapStyles: ThemeUIStyleObject = {
  display: "flex",
  justifyContent: "center",
  alignContent: "center",
};

export const sloganWrapStyles: ThemeUIStyleObject = {
  color: "white",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  mt: 8,
  fontSize: "tinyText",
  fontFamily: "heading",
  letterSpacing: "1.5px",
};

export const iconLogoStyles: ThemeUIStyleObject = {
  fill: "white",
  width: "22px",
  height: "22px",
  pl: 2,
  pr: 2,
};

export const linkListStyles: ThemeUIStyleObject = {
  padding: 0,
  margin: 0,
  listStyle: "none",
  display: "flex",
  flexDirection: "column",
  textAlign: ["center", "left"],
};

export const linkStyles: ThemeUIStyleObject = {
  display: "inline-block",
  fontFamily: "heading",
  color: "white",
  px: 4,
  textDecoration: "none",
  marginBottom: 3,
  letterSpacing: "0.415em",
  fontSize: "smText",
  lineHeight: "normal",
  transition: "opacity 0.2s ease-in",
  ":hover, :focus": {
    opacity: 0.7,
  },
};
